export default class NewsModel {
  titleLabel: string;
  buttonLabel: string;
  url: string;
}